import React from "react";

export interface OrganizationContextManager{
  organizationID: string | null;
  setOrganizationID: (orgID: string | null) => void;
};

export const OrganizationContext = React.createContext<OrganizationContextManager | null>(null);
